import React, { useEffect, useState } from "react";
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import Typography from '@visa/vds/typography';
import DialogCardHeadIcon from '@visa/vds/dialog-card-head-icon';
import Icon from '@visa/vds/icon';
import {userService} from '../services/user.service';

const MCSTimeoutDialog = (props) => {

    const countdownLimit = 60; //60 secs
    const [countdown,setCountdown] = useState(countdownLimit);

    const stayLoggedIn = async () =>{
        if(typeof props.keepAlive == 'function'){
            await props.keepAlive();
        }else{
            console.log("No function found")
        }
        
        props.setTimeOut(false);
    }

    const logOff = async () => {
        if (typeof props.logOff == 'function') {
            await props.logOff();
        } else {
            console.log("No function found")
        }
        if (typeof props.logOff == 'function') {
            await props.logOff();
        }
        props.setTimeOut(false);
    }

    useEffect(() => {
        if(countdown > 0){
            const timer = setTimeout(() => {
                setCountdown(countdown-1);
            }, 1000);
        }else{
            
            window.location.href=process.env.REACT_APP_VOLHOME;
        }
      });

    return (

    <Dialog
        aria-describedby="Session Timeout"
        onExit={() => { }}
        open={props.timeout}
        titleId="dialog-session-timeoujt"
        type="warning"
    >
        <DialogCardHead>
            <DialogCardHeadIcon>
                <Icon name="warning" resolution="low" />
            </DialogCardHeadIcon>
            <DialogCardHeadTitle id="dialog-title-manage-filegroups">Session Timeout</DialogCardHeadTitle>
        </DialogCardHead>
        <DialogCardBody id="dialog-description-manage-filegroups-field">
            {
                <Typography>
                    You are being timed-out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged off automatically.    
                </Typography>
            }
        </DialogCardBody>
        <DialogCardFooter>
            <ButtonGroup direction="right">
                <ButtonText onClick={()=>stayLoggedIn()} colorScheme="primary">
                    Stay Logged In ({countdown})
                </ButtonText>
                    <ButtonText onClick={() => logOff()} colorScheme="secondary">
                    Log Off
                </ButtonText>
            </ButtonGroup>
        </DialogCardFooter>
    </Dialog>
    )
}


export default MCSTimeoutDialog